<template>
  <div
    v-if="announcementStr !== ''"
    class="bg-grey-10 rounded-lg p-3 text-[14px] leading-[24px] mb-[24px] mx-[24px] font-aktiv-grotesk"
    v-html="announcementStr"
  ></div>
  <div
    v-if="scheduleCallout && scheduleCallout.headerTitle && scheduleCallout.headerSubtitle"
    class="bg-grey-10 rounded-lg py-3 px-4 leading-[24px] mx-[24px] font-aktiv-grotesk"
  >
    <div class="flex flex-col gap-1">
      <p class="text-[16px] font-aktiv-grotesk-medium">
        <html-to-vue :html="scheduleCallout.headerTitle"></html-to-vue>
      </p>
      <p class="text-[14px]">
        <html-to-vue :html="scheduleCallout.headerSubtitle"></html-to-vue>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AnnouncementPanel',
  props: {
    announcementStr: {
      type: String,
      default: '',
    },
    scheduleCallout: {
      type: Object,
      default: () => null,
    },
  },
  data() {
    return {
      anchors: [],
    };
  },
  updated() {
    if (this.announcementStr === '') return;
    this.anchors = this.$el.getElementsByTagName('a'); // Not iterable

    Array.from(this.anchors).forEach(anchor => {
      anchor.addEventListener('click', this.useVueRouter);
    });
  },
  beforeUnmount() {
    if (!this.anchors) return;

    Array.from(this.anchors).forEach(anchor => {
      anchor.removeEventListener('click', this.useVueRouter);
    });
  },
  methods: {
    useVueRouter(e) {
      if (e.currentTarget instanceof Element) {
        const href = e.currentTarget.getAttribute('href') || '';
        if (href.startsWith('http')) return;

        e.preventDefault();

        // Use vue router
        this.$router.push(href);
      }
    },
  },
};
</script>

<style scoped></style>
